export default function Signal({ label, value, type }) {
  const colors = {
    green: "bg-green-100 text-green-700",
    yellow: "bg-yellow-100 text-yellow-700",
    red: "bg-red-100 text-red-700",
  };

  return (
    <div className={`px-4 py-2 rounded-full text-sm font-medium ${colors[type]}`}>
      {label}: <strong>{value}</strong>
    </div>
  );
}
